import { useState } from "react";
import { Inp } from "../ui/Inp";
import { C } from "../../constants/theme";
import { useColarLink } from "../../hooks/useColarLink";
import { BotaoColarLink } from "./BotaoColarLink";

/* Link do MakerWorld na edição do produto.

   Link de modelo do MakerWorld é comprido e não diz nada pra quem lê (".../pt/
   models/1234567-nome-do-modelo#profileId-987"): depois de colado ele só ocupa
   espaço no formulário. Então, com um link válido guardado, o campo se recolhe
   e sobra o botão de abrir — com "Trocar" pra quem precisa editar.

   Sem link (ou com link inválido) o campo aparece normalmente. Colar um link
   válido recolhe na hora, que é o caminho comum: copiei no navegador, colei
   aqui, não quero mais ver isso. */
const VALIDO = /^https?:\/\/\S+$/i;

export function LinkProdutoMakerWorld({ valor, onChange, desabilitado }) {
  const [editando, setEditando] = useState(false);
  const link = (valor || "").trim();
  const valido = VALIDO.test(link);
  const mostrarCampo = editando || !valido;

  // Colar já recolhe: o link válido entra e o campo sai da frente.
  const colar = useColarLink(
    (novo) => { onChange(novo); if (VALIDO.test(novo.trim())) setEditando(false); },
    { ativo: mostrarCampo && !desabilitado },
  );

  const rotuloBotao = { background:"none", border:"none", color:C.muted, fontSize:11.5, fontWeight:700, cursor:"pointer", padding:0, textDecoration:"underline" };

  if (!mostrarCampo) {
    return (
      <div>
        <div style={{ color:C.muted, fontSize:12, fontWeight:600, letterSpacing:1, marginBottom:4 }}>LINK DO MAKERWORLD</div>
        <div style={{ display:"flex", alignItems:"center", gap:12, flexWrap:"wrap" }}>
          <a href={link} target="_blank" rel="noopener noreferrer"
            style={{ display:"inline-flex", alignItems:"center", gap:6, border:"1.5px solid " + C.accent2, color:C.accent2, borderRadius:8, padding:"7px 14px", fontSize:12.5, fontWeight:700, textDecoration:"none" }}>
            🧩 Abrir link ↗
          </a>
          <button type="button" style={rotuloBotao} disabled={desabilitado}
            onClick={() => setEditando(true)}>Trocar</button>
          <button type="button" style={{ ...rotuloBotao, color:C.danger }} disabled={desabilitado}
            onClick={() => { onChange(""); setEditando(true); }}>Remover</button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display:"flex", gap:8, alignItems:"flex-end" }}>
        <div style={{ flex:1, minWidth:0 }}>
          <Inp label="LINK DO MAKERWORLD (opcional)" value={valor || ""} disabled={desabilitado}
            placeholder="https://makerworld.com/pt/models/…"
            /* `editando` também no digitar: sem isso o campo se recolhia no
               meio da digitação, no caractere que deixa a URL válida. */
            onChange={e => { setEditando(true); onChange(e.target.value); }}
            onKeyDown={e => { if (e.key === "Enter" && valido) { e.preventDefault(); setEditando(false); } }} />
        </div>
        <BotaoColarLink colar={colar} desabilitado={desabilitado} style={{ minHeight:38 }} />
        {valido && <button type="button" onClick={() => setEditando(false)} disabled={desabilitado}
          style={{ flexShrink:0, minHeight:38, background:"transparent", border:"1.5px solid " + C.accent2, color:C.accent2, borderRadius:8, padding:"0 12px", fontSize:12.5, fontWeight:700, cursor:"pointer" }}>Pronto</button>}
      </div>
      {link && !valido && <p role="alert" style={{ margin:"6px 0 0", color:C.danger, fontSize:12 }}>O link precisa começar com https://</p>}
      <p style={{ margin:"6px 0 0", color:C.muted, fontSize:11.5 }}>Copiou o link do modelo? Ctrl+V aqui já cola.</p>
    </div>
  );
}
